/*eslint-disable multiline-ternary */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Col } from 'react-bootstrap';
import {
  ProviderDetailedWomen,
  ProviderDetailedMen,
  ProviderImageUnknownGender,
} from '../../../../../img/findcare/FindCareSVG';
import { t } from 'i18next';
const noDataMessage = t('find_provider.data_not_available');

const LeftSection = ({ doctorDetails, addressIndex }) => {
  return (
    <Col sm={3}>
      <div className="secondary-background profile-section">
        <div className="profile-image text-center mx-auto">
          {doctorDetails.Gender === 'Female' && (
            <ProviderDetailedWomen
              circleClassName="provider-details-profile-circle"
              className="provider-details-profile-image"
            />
          )}
          {doctorDetails.Gender === 'Male' && (
            <ProviderDetailedMen
              circleClassName="provider-details-profile-circle"
              className="provider-details-profile-image"
            />
          )}
          {(!doctorDetails.Gender || doctorDetails.Gender === 'Unknown') && (
            <ProviderImageUnknownGender
              circleClassName="provider-details-profile-circle"
              className="provider-details-profile-image"
            />
          )}
        </div>
        <div className="other-info">
          <p className="paragraph-font primary-text">
            <span className="label-text-bold">{t('find_provider.gender')}</span>{' '}
            <br />
            {['Male', 'Female'].includes(doctorDetails.Gender)
              ? doctorDetails.Gender
              : 'Unknown'}
          </p>
          <p className="paragraph-font primary-text">
            <span className="label-text-bold">{t('find_provider.age')}</span>{' '}
            <br />
            {doctorDetails.Age
              ? `${doctorDetails.Age} Years Old`
              : noDataMessage}
          </p>
          <p className="paragraph-font primary-text">
            <span className="label-text-bold">{t('find_provider.email')}</span>{' '}
            <br />
            {doctorDetails.EmailAddress ? (
              <a
                className="secondary-2 text-break"
                href={`mailto:${doctorDetails.EmailAddress}`}
              >
                {doctorDetails.EmailAddress}
              </a>
            ) : doctorDetails?.DoctorAfflFacilities[addressIndex]
                ?.EmailAddress ? (
              <a
                className="secondary-2 text-break"
                href={`mailto:${doctorDetails?.DoctorAfflFacilities[addressIndex]?.EmailAddress}`}
              >
                {
                  doctorDetails?.DoctorAfflFacilities[addressIndex]
                    ?.EmailAddress
                }
              </a>
            ) : (
              noDataMessage
            )}
          </p>
          <p className="paragraph-font primary-text">
            <span className="label-text-bold">
              {t('find_provider.website')}
            </span>{' '}
            <br />
            {doctorDetails?.DoctorAfflFacilities[addressIndex]?.Website &&
            doctorDetails?.DoctorAfflFacilities[addressIndex]?.Website !=
              null ? (
              <a
                className="secondary-2 text-break"
                target={'_blank'}
                rel="noopener noreferrer"
                href={
                  doctorDetails?.DoctorAfflFacilities[addressIndex]?.Website
                }
              >
                {doctorDetails?.DoctorAfflFacilities[addressIndex]?.Website}
              </a>
            ) : (
              noDataMessage
            )}
          </p>
          {doctorDetails.SpokenLanguages && (
            <>
              <p className="paragraph-font primary-text mb-0">
                <span className="label-text-bold">
                  {t('find_provider.language_spoken')}
                </span>
              </p>
              {doctorDetails.SpokenLanguages?.length ? (
                <ul className="list-unstyled">
                  {doctorDetails.SpokenLanguages.map((lang, index) => (
                    <li key={lang}>{lang}</li>
                  ))}
                </ul>
              ) : (
                noDataMessage
              )}
            </>
          )}
        </div>
      </div>
    </Col>
  );
};
export default LeftSection;
